/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Grid from '@material-ui/core/Grid';
import {
    object, number, string, func, shape, arrayOf, bool,
} from 'prop-types';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import  StatusTracking from '../../common/StatusTracking';
import AddressHelper from '../OrderDetails/Helper/AddressHelper';
import EventDispatcher from '../../state/reducers/EventDispatcher';
import { dateMMMMDDYYYY } from '../../utils/dateString';
import { cipher } from '../../utils/crypto';
import configENV from '../../config';
import { isEmpty } from '../../utils/object';

import { secureProtocol } from '../../utils/secureProtocol';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import { getLanguageName } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';

const { PERSIST_KEY } = configENV;

class DesktopOrderListItem extends React.Component {
    handleViewDetailsClicked = (
        uuid,
        orderNumber,
        paymentStatus,
        status,
        trackingNumber,
        carrier,
    ) => {
        const { match, fetchOrderDetails, history } = this.props;
        // If guest user clicked on the view details button, call fetchOrderDetails to update the order details page
        if (uuid && match.params && match.params.uuid === uuid) {
            fetchOrderDetails(uuid, orderNumber, null, {
                update: true,
                paymentStatus,
                status,
                trackingNumber,
                carrier,
            });
        } else if (uuid) {
            // if logged in user clicked on the view details button, redirect to the order detail page
            const cipherKey = uuid.slice(0, 8);
            const cryptedOrderNumber = cipher(cipherKey)(orderNumber).replace(
                /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
                '$1-$2-$3-$4-$5',
            );
            const validStatus = status || paymentStatus;
            const cryptedStatus = cipher(cipherKey)(validStatus).replace(
                /^(.{8})(.{4})(.{4})(.{4})(.+)$/,
                '$1-$2-$3-$4-$5',
            );
            history.push([
                '/account/orders/',
                uuid,
                '/',
                cryptedOrderNumber,
                '/0/',
                cryptedStatus,
            ].join(''));
        }
    };

    subscriptionInterval = (i) => {
        const SUBSCRIPTION_INTERVALS = {
            1: 'Delivers every 1 week',
            4: 'Delivers every 4 weeks',
            6: 'Delivers every 6 weeks',
            8: 'Delivers every 8 weeks',
            30: 'Delivers monthly',
        };
        return SUBSCRIPTION_INTERVALS[i] ? SUBSCRIPTION_INTERVALS[i] : i;
    }

    render() {
        const {
            items, classes, index, uuid, orderNumber, hasOrderSpecific, userProfile, brand, dataDictionary,
        } = this.props;
        if (!userProfile) {
            return null;
        }
        const hasAuthenticated = userProfile?.isAuthenticated || '';
        const {
            id, recpFirstName, recipientLastName, recipientFirstName, recpLastName, modifyOrder, status, paymentStatus, carrier, trackingNumber,
            productBrand, subscriptionType, estimatedDeliveryDate, arrivalEndDate, itemDetailList, interval, recipientDetail,
        } = items;

        // There is a discrepancy of Order Details' API response between login and guest account.
        let {
            prdImgCtg, productName, itemType, productSku, deliveryDate,
        } = items;
        const estDeliveryDate = estimatedDeliveryDate || arrivalEndDate;
        const deliveryDate2 = dateMMMMDDYYYY(estDeliveryDate);
        if (!isEmpty(itemDetailList)) {
            ([{
                prdImgCtg, itemType, productSku, productName, deliveryDate,
            }] = itemDetailList);
        }
        const productImageURL = prdImgCtg ? secureProtocol(prdImgCtg) : prdImgCtg;
        const language = getLanguageName();
        return (
            <React.Fragment key={id}>
                <Grid container className="orderItemGrid">
                    <Grid container>
                        <Grid className="orderStatusInfo" item xs={12}>
                            {index === 0 && brand.code !== '08F' && brand.code !== 'CAN' && (
                                <Grid container>
                                    <Grid item xs={12}>
                                        <StatusTracking
                                            status={status || paymentStatus}
                                        />
                                    </Grid>
                                    {deliveryDate2
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className="gray-color uppercase">Arrives: </span>
                                                <span className="bold">{deliveryDate2}</span>
                                            </Grid>
                                        ) : null}
                                    {itemType === 'FPT'
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className="gray-color uppercase">Delivered by: </span>
                                                <span className="bold">Local Florist</span>
                                            </Grid>
                                        ) : null}
                                    {itemType === 'GPT'
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className="gray-color uppercase">Item: </span>
                                                <span className="bold">Ship in a gift box</span>
                                            </Grid>
                                        ) : null}
                                    {trackingNumber
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className={classes.labelName}>Tracking: </span>
                                                <span className={classes.fontBold}>{trackingNumber}</span>
                                            </Grid>
                                        ) : null}

                                    {subscriptionType === 'Passport'
                                        ? (
                                            <Grid className="orderDetail" item xs={12}>
                                                <span className={classes.labelName}>Membership Start Date: </span>
                                                <span className={classes.fontBold}>{deliveryDate2}</span>
                                            </Grid>
                                        )
                                        : null}
                                </Grid>
                            )}
                            {index === 0 && (brand?.code === '08F' || brand?.code === 'CAN') && (
                                <Grid container>
                                    <Grid item xs={12}>
                                        <StatusTracking
                                            status={status || paymentStatus}
                                            brand={brand}
                                        />
                                    </Grid>
                                </Grid>
                            )}
                        </Grid>
                        <Grid className="productInnerDiv" item xs={12}>
                            <div className="headerItemLabel">
                                {language === '/en' ? 'Product Information' : dataDictionary?.['Product Information'] || 'Product Information'}
                            </div>
                            <div className="productImg">
                                <img src={productImageURL} alt={productSku} />
                                <div className="productName">
                                    {interval ? (
                                        <div className="subscription">
                                            <span className="subscriptionDelivery">{this.subscriptionInterval(interval)}</span>
                                            <Link to="/account/subscriptions">Manage Subscriptions</Link>
                                        </div>
                                    ) : ''}
                                    <div className="productContainer">
                                        <div className="productTitle">
                                            {language === '/en' ? 'Product' : dataDictionary?.['Product'] || 'Product'}
                                            <div className="productInfo">{productName}</div>
                                        </div>
                                        <div className="productTitle">
                                            {language === '/en' ? 'Delivery Address' : dataDictionary?.['Delivery Address'] || 'Delivery Address'}
                                            <AddressHelper address={recipientDetail?.address} />
                                        </div>
                                        <div className="productTitle">
                                            {language === '/en' ? 'Delivery Date' : dataDictionary?.['Delivery Date'] || 'Delivery Date'}
                                            <div className="productInfo">{deliveryDate && dateMMMMDDYYYY(deliveryDate, dataDictionary)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    {brand.code !== '08F' && brand.code !== 'CAN' && (
                        <Grid className="productInnerDiv" item xs={3}>
                            {index === 0 ? (
                                <div>
                                    <div className="bold">
                                        {recipientFirstName || recpFirstName} {recipientLastName || recpLastName  }
                                    </div>
                                    <div className="brandName">
                                        {productBrand}
                                    </div>
                                    <div className={hasOrderSpecific ? 'hide-view-details' : 'position-absolute-bottom'}>
                                        {hasAuthenticated && (
                                            <Button
                                                variant="contained"
                                                className="secondary float-left margin-bottom-2x"
                                                onClick={() => this.handleViewDetailsClicked(
                                                    uuid,
                                                    orderNumber,
                                                    paymentStatus,
                                                    status,
                                                    trackingNumber,
                                                    carrier,
                                                )}
                                            >
                                                {modifyOrder === 'true'
                                                    ? 'View Details / Modify'
                                                    : 'View Details'}
                                            </Button>
                                        )}
                                    </div>
                                </div>

                            )
                                : <span />}
                        </Grid>
                    )}
                </Grid>
            </React.Fragment>
        );
    }
}
DesktopOrderListItem.propTypes = {
    classes: object.isRequired,
    items: shape({
        brandId: string,
        productSku: string,
        productName: string,
        recpFirstName: string,
        recpLastName: string,
        shipDate: string,
        paymentStatus: string,
        estimatedDeliveryDate: string,
        trackingNumber: string,
        itemType: string,
        sfItemType: string,
        addonType: string,
        parentLineNumber: string,
        childLineNumber: string,
        flexDate: string,
        flexMessage: string,
        flexGuaranteedFlag: string,
        prdImgCtg: string,
        prdImgTmn: string,
        arrivalStartDate: string,
        arrivalEndDate: string,
        carrier: string,
        subscriptionType: string,
        interval: string,
        duration: string,
        modifyOrder: string,
        status: string,
        itemDetailList: arrayOf(
            shape({
                cardMessage: string,
                productName: string,
                productSku: string,
                productBrand: string,
                price: string,
                itemType: string,
                sfItemType: string,
                addonType: string,
                parentLineNumber: string,
                childLineNumber: string,
                prdImgCtg: string,
                prdImgTmn: string,
            }),
        ),
    }).isRequired,
    index: number.isRequired,
    orderNumber: string.isRequired,
    uuid: string.isRequired,
    match: object,
    history: object,
    fetchOrderDetails: func.isRequired,
    hasOrderSpecific: bool.isRequired,
    userProfile: shape({
        isAuthenticated: bool.isRequired,
    }).isRequired,
    brand: object.isRequired,
    dataDictionary: object.isRequired,
};

DesktopOrderListItem.defaultProps = {
    match: {},
    history: {},
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isAuthenticated: newState.isAuthenticated,
        dataDictionary: getDataDictionary(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchOrderDetails: (uuid, orderNumber, zipCode, options) => dispatch(EventDispatcher.fetchOrderDetails(
        uuid,
        orderNumber,
        zipCode,
        options,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(DesktopOrderListItem));
